import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useToast, useFetch, useModal, useGrid, usePopup, useResource, usePage } from "@/comn/hooks";
import { URLS, SG_BLL_DTLS, SG_BLL_ITM_LIST } from "./services/OsciBllService"; // 서비스
import { APIS_COMN, SF_COMN_BLL_INFO, SF_COMN_BLL_SRCH } from "@/tz/go/egaz/osci/colt/comn/OsciColtComnService"; // 공통 서비스
import { colEnvs, colUtils } from "@/tz/go/egaz/osci/colt/comn";

/*
 * Bill Detail
 * !== 고지 상세 ==!
 */
export const OSCI0401002Q = () => {
    const resource = useResource({
        defaultSchema: [],
    });
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003", "auth_osci0021"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { bllMgmtId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!
    const popup = usePopup();
    const { scrnId } = useParams();
    let pgeTitle = "";
    const [vsdPrintBllBtn, setPrintBllBtn] = useState(false);
    const [vsdPrintRcptBtn, setPrintRcptBtn] = useState(false);

    if (menuId?.includes("menu_coli")) {
        pgeTitle = "T_NTFC_DTL";
    } else if (menuId?.includes("menu_olmi")) {
        pgeTitle = "T_OIL_NTFC_DTL";
    }

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0056" },
            { area: "comnCd", comnCd: "OSC0057" },
            { area: "comnCd", comnCd: "OSC0058" },
            { area: "comnCd", comnCd: "OSC0065" },
            { area: "comnCd", comnCd: "OSC0067" },
            { area: "comnCd", comnCd: "OSC0072" },
            { area: "comnCd", comnCd: "OSC0018" },
            { area: "comnCd", comnCd: "OSC0023" },
            { area: "comnCd", comnCd: "OSC0166" },
            { area: "coCd" },
            { area: "bnkCd" },
        ],
    });

    const [vsbTansad, setVsbTansad] = useState(false);
    const [vsbBll, setVsbBll] = useState(false);
    const [vsbDspo, setVsbDspo] = useState(false);
    const [vsbRcpt, setVsbRcpt] = useState(false);
    const [vsdDtls, setVsdDtls] = useState(false);
    const [vsdErrs, setVsdErrs] = useState(false);
    const [vsdItms, setVsdItms] = useState(false);
    const [isCmbn, setCmbn] = useState(false);

    const [bllDtlList, setBllDtlList] = useState(comnUtils.getGridData([]));
    const [bllItmList, setBllItmList] = useState(comnUtils.getGridData([]));
    const [isTzs, setTzs] = useState(true);

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */

    const form = {
        // Bill Search !== 고지 검색 ==!
        bllSrch: useForm({
            defaultSchema: SF_COMN_BLL_SRCH,
            defaultValues: {},
        }),
        // Bill General !== 고지 일반 ==!
        bllGnrl: useForm({
            defaultSchema: SF_COMN_BLL_INFO,
            defaultValues: {},
        }),
    };

    const today = new Date();

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Bill Detail List !== 고지 상세 목록 ==!
        bllDtlList: useGrid({
            defaultSchema: SG_BLL_DTLS,
        }),
        bllItmList: useGrid({
            defaultSchema: SG_BLL_ITM_LIST,
        }),
    };

    const readyFunc = {
        noData: () => {
            form.bllGnrl.clearValues();
        },
        resetView: () => {
            setVsbBll(false);
            setVsbTansad(false);
            setVsbDspo(false);
            setVsbRcpt(false);
            setVsdDtls(false);
        },
        readyBll: (data: any) => {
            form.bllGnrl.setValues({
                ...data.bllInfo.content,
            });

            form.bllSrch.setValues({
                ...data.bllInfo.content,
            });

            if (data.bllInfo.content != null) {
                setVsbBll(true);
            }
            if (data.bllInfo.content.reffKeyTpCd == "T") {
                setVsbTansad(true);
            }
            if (data.bllInfo.content.bllStatCd == "F") {
                setVsbDspo(true);
            }
            if (data.bllInfo.content.bllStatCd == "C") {
                setVsbRcpt(true);
            }
            if (data.bllInfo.content.bllStatCd == "D" || data.bllInfo.content.bllSendStatCd == "F") {
                setVsdErrs(true);
            }
            if (data.bllInfo.content.currCd == "USD") {
                setTzs(false);
            }
            if (data.bllInfo.content.bllMgmtId?.startsWith("G")) setCmbn(true);
            else setCmbn(false);

            if (data.bllInfo.content.ctrlNo) setPrintBllBtn(true);
            else setPrintBllBtn(false);

            if (data.bllInfo.content.rcptAmt > 0) setPrintRcptBtn(true);
            else setPrintRcptBtn(false);

            if (data.bllInfo.content)
                if (data.bllInfo.content.reffKeyTpCd == null || data.bllInfo.content.reffKeyTpCd == "") {
                    form.bllGnrl.setValue("reffKey", "");
                } else {
                    if (data.bllInfo.content.reffKeyNo1) {
                        if (data.bllInfo.content.reffKeyTpCd == "T" || data.bllInfo.content.reffKeyTpCd == "B") {
                            form.bllGnrl.setValue(
                                "reffKey",
                                data.bllInfo.content.reffKeyNo1 +
                                    "-" +
                                    data.bllInfo.content.reffKeyNo2 +
                                    "-" +
                                    data.bllInfo.content.reffKeyNo3,
                            );
                        } else if (data.bllInfo.content.reffKeyTpCd == "A") {
                            form.bllGnrl.setValue("reffKey", data.bllInfo.content.reffKeyNo1);
                        } else {
                            if (data.bllInfo.content.reffKeyNo4 == null || data.bllInfo.content.reffKeyNo4 == "") {
                                form.bllGnrl.setValue(
                                    "reffKey",
                                    data.bllInfo.content.reffKeyNo1 +
                                        "-" +
                                        data.bllInfo.content.reffKeyNo2 +
                                        "-" +
                                        data.bllInfo.content.reffKeyNo3,
                                );
                            } else {
                                form.bllGnrl.setValue(
                                    "reffKey",
                                    data.bllInfo.content.reffKeyNo1 +
                                        "-" +
                                        data.bllInfo.content.reffKeyNo2 +
                                        "-" +
                                        data.bllInfo.content.reffKeyNo3 +
                                        "-" +
                                        data.bllInfo.content.reffKeyNo4,
                                );
                            }
                        }
                    }
                }

            if (data.bllInfo.content.dcltNm != null && data.bllInfo.content.dcltNm != "") {
                form.bllGnrl.setValue(
                    "dcltTinNm",
                    colUtils.setMask(data.bllInfo.content.dcltTin, "tin") + " (" + data.bllInfo.content.dcltNm + ")",
                );
            } else {
                form.bllGnrl.setValue("dcltTinNm", colUtils.setMask(data.bllInfo.content.dcltTin, "tin"));
            }

            if (data.bllInfo.content.exppnImppnNm != null && data.bllInfo.content.exppnImppnNm != "") {
                form.bllGnrl.setValue(
                    "exppnImppnTinNm",
                    colUtils.setMask(data.bllInfo.content.exppnImppnTin, "tin") +
                        " (" +
                        data.bllInfo.content.exppnImppnNm +
                        ")",
                );
            } else {
                form.bllGnrl.setValue("exppnImppnTinNm", colUtils.setMask(data.bllInfo.content.exppnImppnTin, "tin"));
            }

            if (data.bllInfo.content.pyerTpCd == "T") {
                if (data.bllInfo.content.pyerNm != null && data.bllInfo.content.pyerNm != "") {
                    form.bllGnrl.setValue(
                        "pyerMgmtNoNm",
                        colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin") +
                            " (" +
                            data.bllInfo.content.pyerNm +
                            ")",
                    );
                } else {
                    form.bllGnrl.setValue("pyerMgmtNoNm", colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin"));
                }
            } else {
                if (data.bllInfo.content.pyerMgmtNo == null || data.bllInfo.content.pyerMgmtNo == "") {
                    form.bllGnrl.setValue("pyerMgmtNoNm", data.bllInfo.content.pyerNm);
                } else {
                    if (data.bllInfo.content.pyerNm != null && data.bllInfo.content.pyerNm != "") {
                        form.bllGnrl.setValue(
                            "pyerMgmtNoNm",
                            colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin") +
                                " (" +
                                data.bllInfo.content.pyerNm +
                                ")",
                        );
                    } else {
                        form.bllGnrl.setValue("pyerMgmtNoNm", colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin"));
                    }
                }
            }

            if (data.bllInfo.content.bllRgsrId && data.bllInfo.content.bllRgsrNm) {
                form.bllGnrl.setValue(
                    "bllRgsrIdNm",
                    data.bllInfo.content.bllRgsrId + "/" + data.bllInfo.content.bllRgsrNm,
                );
            } else if (data.bllInfo.content.bllRgsrId) {
                form.bllGnrl.setValue("bllRgsrIdNm", data.bllInfo.content.bllRgsrId);
            } else if (data.bllInfo.content.bllRgsrNm) {
                form.bllGnrl.setValue("bllRgsrIdNm", data.bllInfo.content.bllRgsrNm);
            }

            if (data.bllInfo.content.bllTpCd && data.bllInfo.content.bllTpCd === "G") setVsdDtls(true);
            if (data.bllInfo.content.bllDtls) {
                setBllDtlList(comnUtils.getGridData(data.bllInfo.content.bllDtls));
            }
            if (data.bllInfo.content.bllItms && data.bllInfo.content.bllItms.length > 0) {
                setVsdItms(true);
                setBllItmList(comnUtils.getGridData(data.bllInfo.content.bllItms));
            }
        },
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Bill !== 고지 조회 ==!
        getBll: useFetch({
            api: (data) => APIS_COMN.getBll(bllMgmtId),
            enabled: !!bllMgmtId,
            onSuccess: (data) => {
                if (data.bllInfo.content != null) {
                    readyFunc.readyBll(data);
                } else {
                    toast.showToast({ type: "warning", content: "msg.osc.00050" });
                    readyFunc.noData();
                }
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00182", // Please check Bill No.
                });
            },
            showToast: true,
        }),
        getBllSrch: useFetch({
            api: (data) => APIS_COMN.getBllDtl(form.bllSrch.getValues()),
            onSuccess: (data) => {
                if (data.bllInfo.content != null) {
                    readyFunc.resetView();
                    readyFunc.readyBll(data);
                } else {
                    toast.showToast({ type: "warning", content: "msg.osc.00050" });
                    readyFunc.noData();
                }
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00182", // Please check Bill No.
                });
            },
            showToast: true,
        }),
        printBill: useFetch({
            api: (data) => {
                const bllMgmtId = form.bllGnrl.getValue("bllMgmtId");
                return APIS_COMN.printBill(bllMgmtId);
            },
            onSuccess: (data) => {
                modal.openModal({
                    type: "pdf",
                    data: data,
                    thumbnail: true,
                    download: true,
                    print: true,
                });
            },
            onError: (error) => {},
            showToast: true,
        }),
        printRcpt: useFetch({
            api: (data) => {
                const bllMgmtId = form.bllGnrl.getValue("bllMgmtId");
                return APIS_COMN.printRcpt(bllMgmtId);
            },
            onSuccess: (data) => {
                modal.openModal({
                    type: "pdf",
                    data: data,
                    thumbnail: true,
                    download: true,
                    print: true,
                });
            },
            onError: (error) => {},
            showToast: true,
        }),
        zmpSend: useFetch({
            api: (data) => APIS_COMN.testZmpSend(form.bllSrch.getValues()),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00031", // Processed successfully.
                });
            },
            onError: () => {},
            showToast: true,
        }),
        reissBll: useFetch({
            api: (data) => {
                return APIS_COMN.reissBll(data);
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006", //Processed successfully.
                    onClose: () => {
                        fetch.getBll.fetch();
                    },
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00015", //An error occurred during processing.
                });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        getBllSrch: () => {
            form.bllSrch.handleSubmit((data) => {
                let bllNo = form.bllSrch.getValue("bllNo");

                if (bllNo) {
                    bllNo = bllNo.trim(); // 앞뒤 공백 제거

                    // "X-XXXX-XX-XXXXXXX-X"(bllMgmtId 마스크) 패턴이면 '-' 제거
                    if (/^[A-Za-z0-9]-[A-Za-z0-9]{4}-[A-Za-z0-9]{2}-[A-Za-z0-9]{7}-[A-Za-z0-9]$/.test(bllNo)) {
                        bllNo = bllNo.replaceAll("-", "");
                    }

                    form.bllSrch.setValue("bllNo", bllNo); // 정규화된 값을 폼에 반영
                }

                let bllTpCd = form.bllSrch.getValue("bllTpCd");
                let bllSysmCd = form.bllSrch.getValue("bllSysmCd");
                let bllYy = form.bllSrch.getValue("bllYy");
                let bllSrno = form.bllSrch.getValue("bllSrno");
                let bllDgr = form.bllSrch.getValue("bllDgr");
                // Validation Check !== 밸리데이션 체크 ==!
                if (!!!bllNo && (!!!bllTpCd || !!!bllSysmCd || !!!bllYy || !!!bllSrno || !!!bllDgr)) {
                    modal.openModal({
                        content: "msg.osc.00281",
                    });
                } else {
                    fetch.getBllSrch.fetch();
                }
            })();
        },
        printBill: () => {
            if (form.bllGnrl.getValue("ctrlNo") != null) {
                fetch.printBill.fetch();
            } else {
                modal.openModal({
                    content: "msg.osc.00083",
                });
            }
        },
        printRcpt: () => {
            if (form.bllGnrl.getValue("ctrlNo") != null) {
                fetch.printRcpt.fetch();
            } else {
                modal.openModal({
                    content: "msg.osc.00083",
                });
            }
        },
        testZmpSend: () => {
            fetch.zmpSend.fetch();
        },
        reissBll: form.bllGnrl.handleSubmit(
            () => {
                const data = {
                    ...form.bllGnrl.getValues(),
                };
                modal.openModal({
                    content: "msg.osc.00180", //Do you want to execute?
                    onConfirm: () => {
                        fetch.reissBll.fetch(data);
                    },
                });
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.osc.00003" });
            },
        ),
    };

    const render = {
        grid_bllDtlList: {
            head: {},
            cell: {
                bllMgmtId: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <span>
                            {`${rowValues.bllTpCd}-${rowValues.bllSysmCd}-${rowValues.bllYy}-${rowValues.bllSrno}-${rowValues.bllDgr}`}
                        </span>
                    );
                },
            },
            edit: {},
        },
        grid_bllItmList: {
            head: {},
            cell: {
                bllItmAmt: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return isTzs ? formatAmount(rowValues.bllItmTzsAmt) : formatAmount(rowValues.bllItmAmt);
                },
            },
            edit: {},
        },
    };
    const formatAmount = (amount: number | null | undefined) => {
        return Number(amount ?? 0).toLocaleString();
    };

    useEffect(() => {
        form.bllSrch.setEditable(true);
        form.bllGnrl.setEditable(false);
        if (comnUtils.isPopup()) {
            form.bllSrch.setEditable(false);
        }
    }, []);

    return (
        <Page title={t(pgeTitle)}>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.bllSrch.schema.bllNo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Label {...form.bllSrch.schema.bllMgmtId}></Group.Label>
                            <Group.Field size={4}>
                                <Group.Control
                                    {...form.bllSrch.schema.bllTpCd}
                                    onPaste={(e: any) => {
                                        e.preventDefault();
                                        const data = e.clipboardData.getData("Text").replaceAll("-", "");

                                        form.bllSrch.setValue("bllTpCd", data.substring(0, 1));
                                        form.bllSrch.setValue("bllSysmCd", data.substring(1, 5));
                                        form.bllSrch.setValue("bllYy", data.substring(5, 7));
                                        form.bllSrch.setValue("bllSrno", data.substring(7, 14));
                                        form.bllSrch.setValue("bllDgr", data.substring(14, 15));
                                    }}
                                />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllSrch.schema.bllSysmCd} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllSrch.schema.bllYy} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllSrch.schema.bllSrno} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllSrch.schema.bllDgr} />
                            </Group.Field>
                        </Group.Row>
                    </Group.Section>
                    {!comnUtils.isPopup() && (
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.bllSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getBllSrch();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    )}
                </Group.Body>
            </Group>
            {vsbTansad && (
                <Group>
                    <Group.Body>
                        <Group.Title title={"L_TANSAD_GNRL"} titleSize={2}></Group.Title>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.tansadNo} />
                                <Group.Control {...form.bllGnrl.schema.tansadDt} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.regm} />
                                <Group.Control {...form.bllGnrl.schema.csclPlnCd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.exppnImppnTinNm} />
                                <Group.Control {...form.bllGnrl.schema.dcltTinNm} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.dclrPrcssSttsCd} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            {vsbBll && (
                <>
                    <Group>
                        <Group.Body>
                            <Group.Title title={"L_BLL_GNRL"} titleSize={2}></Group.Title>
                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.bllNo} />
                                    <Group.Control {...form.bllGnrl.schema.bllDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.ctrlNo} />
                                    <Group.Control {...form.bllGnrl.schema.zmpDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.bllTpCdSec} />
                                    <Group.Control {...form.bllGnrl.schema.bllStatCd} />
                                </Group.Row>
                                {!isCmbn && (
                                    <Group.Row>
                                        <Group.Control {...form.bllGnrl.schema.orgCd} />
                                        <Group.Control {...form.bllGnrl.schema.appNm} />
                                    </Group.Row>
                                )}
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.pyerMgmtNoNm} />
                                    <Group.Control {...form.bllGnrl.schema.bllRgsrIdNm} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.reffKeyTpCd} />
                                    <Group.Control {...form.bllGnrl.schema.reffKey} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.currCd} />
                                    <Group.Control {...form.bllGnrl.schema.bllMgmtId} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.feeAmt} />
                                    <Group.Control {...form.bllGnrl.schema.feeTzsAmt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.payDdlnDt} />
                                    <Group.Control {...form.bllGnrl.schema.lastDdlnXtnsDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.xtnsDt} />
                                    <Group.Control {...form.bllGnrl.schema.lastDdlnXtnsRsn} />
                                </Group.Row>
                                {vsdErrs && (
                                    <Group.Row>
                                        <Group.Control {...form.bllGnrl.schema.errRcveDt} />
                                        <Group.Control {...form.bllGnrl.schema.errMsgCn} />
                                    </Group.Row>
                                )}
                            </Group.Section>
                        </Group.Body>
                    </Group>
                    {vsdDtls && (
                        <Group>
                            <Group.Body>
                                {" "}
                                <Layout direction="row">
                                    <Layout.Left>
                                        <Group.Title title={"T_BLL_DTL_1"} titleSize={2}></Group.Title>
                                    </Layout.Left>
                                </Layout>
                                <Grid {...grid.bllDtlList.grid} data={bllDtlList} render={render.grid_bllDtlList} />
                            </Group.Body>
                        </Group>
                    )}
                    {vsdItms && (
                        <Group>
                            <Group.Body>
                                {" "}
                                <Layout direction="row">
                                    <Layout.Left>
                                        <Group.Title title={"T_ITM_LST"} titleSize={2}></Group.Title>
                                    </Layout.Left>
                                </Layout>
                                <Grid {...grid.bllItmList.grid} data={bllItmList} render={render.grid_bllItmList} />
                            </Group.Body>
                        </Group>
                    )}
                </>
            )}
            {vsbDspo && (
                <Group>
                    <Group.Body>
                        <Group.Title title={"L_BLL_CNCL"} titleSize={2}></Group.Title>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.dspoDt} />
                                <Group.Control {...form.bllGnrl.schema.dspoCd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.dspoRmrk} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            {vsbRcpt && (
                <Group>
                    <Group.Body>
                        <Group.Title title={"L_BLL_RCPT"} titleSize={2}></Group.Title>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.payMetdCd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.rcptBnkCd} />
                                <Group.Control {...form.bllGnrl.schema.rcptBnkAcctNo} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.rcptNo} />
                                <Group.Control {...form.bllGnrl.schema.manlRcptRsn} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.rcptAmt} />
                                <Group.Control {...form.bllGnrl.schema.rcptDt} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            {!comnUtils.isPopup() && (
                <Layout direction="row">
                    <Layout.Left>
                        <Button
                            role="list"
                            onClick={() => {
                                navigate(URLS.osci0401001q);
                            }}
                        ></Button>
                    </Layout.Left>
                    <Layout.Right>
                        {vsdPrintRcptBtn && (
                            <Button
                                onClick={() => {
                                    handler.printRcpt();
                                }}
                            >
                                {t("B_PRNT_RCPT")}
                            </Button>
                        )}
                        {vsdPrintBllBtn && (
                            <Button
                                onClick={() => {
                                    handler.printBill();
                                }}
                            >
                                {t("B_PRNT_BLL")}
                            </Button>
                        )}{" "}
                        {process.env.NODE_ENV === "development" && (
                            <>
                                <Button
                                    variant="secondary"
                                    onClick={() => {
                                        handler.testZmpSend();
                                    }}
                                >
                                    {t("B_ZMP_SEND")}
                                </Button>
                                <Button
                                    onClick={() => {
                                        handler.reissBll();
                                    }}
                                >
                                    Reissue
                                </Button>
                            </>
                        )}
                    </Layout.Right>
                </Layout>
            )}
            {comnUtils.isPopup() && (
                <Layout direction="row">
                    <Layout.Right>
                        {vsdPrintRcptBtn && (
                            <Button
                                onClick={() => {
                                    handler.printRcpt();
                                }}
                            >
                                {t("B_PRNT_RCPT")}
                            </Button>
                        )}
                        {vsdPrintBllBtn && (
                            <Button
                                onClick={() => {
                                    handler.printBill();
                                }}
                            >
                                {t("B_PRNT_BLL")}
                            </Button>
                        )}
                        <Button
                            role="close"
                            onClick={() => {
                                popup.close();
                            }}
                        ></Button>
                    </Layout.Right>
                </Layout>
            )}
        </Page>
    );
};
